import Swiper from "swiper";
import $ from "jquery";
export default function () {

    if(document.querySelector('.mp-dynamics__slider-container')) {
        let countSlides = document.querySelectorAll('.mp-dynamics__swiper1 .swiper-slide').length;
        let params = {
            slidesPerView: 1,
            navigation: {
                prevEl: '.mp-dynamics__swiper1__button-prev',
                nextEl: '.mp-dynamics__swiper1__button-next',
            },
            pagination: {
                clickable: true,
                el: '.mp-dynamics__swiper1__swiper-pagination'
            },
            allowTouchMove: false,
            autoHeight: true,
        };
        if(countSlides > 1) {
            //params.loop = true;
        }

        setTimeout(function() {
            new Swiper(".mp-dynamics__slider-container", params);
        }, 500);
    }

    if(document.querySelector('.mp-dynamics__slider-container2')) {
        let countSlides = document.querySelectorAll('.mp-dynamics__swiper2 .swiper-slide').length;
        let params = {
            slidesPerView: 1,
            navigation: {
                prevEl: '.mp-dynamics__swiper2__button-prev',
                nextEl: '.mp-dynamics__swiper2__button-next',
            },
            pagination: {
                clickable: true,
                el: '.mp-dynamics__swiper2 .swiper-pagination'
            },
            allowTouchMove: false,
        };

        new Swiper(".mp-dynamics__slider-container2", params);
    }

    if(document.querySelector('.mp-projects__slider-container')) {
        let countSlides = document.querySelectorAll('.mp-projects__slider-container .swiper-slide').length;

        let desktop = {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 24,
            /*navigation: {
                prevEl: '.mp-projects__swiper__button-prev',
                nextEl: '.mp-projects__swiper__button-next',
            },
            pagination: {
                clickable: true,
                el: '.mp-projects__swiper .swiper-pagination'
            },*/
            allowTouchMove: false,
        };

        if(countSlides> 3) {
            desktop.navigation = {
                prevEl: '.mp-projects__swiper__button-prev',
                nextEl: '.mp-projects__swiper__button-next',
            };
            desktop.pagination = {
                clickable: true,
                el: '.mp-projects__swiper .swiper-pagination'
            }
        }

        let params = {
            slidesPerView: 1,
            slidesPerGroup: 1,
            //slidesPerView: 'auto',
            spaceBetween: 0,
            //loop: true,
            //centeredSlides: true,
            navigation: {
                prevEl: '.mp-projects__swiper__button-prev',
                nextEl: '.mp-projects__swiper__button-next',
            },
            pagination: {
                clickable: true,
                el: '.mp-projects__swiper .swiper-pagination'
            },
            allowTouchMove: false,
            breakpoints: {
                768: desktop
            }
        };

        new Swiper(".mp-projects__slider-container", params);
    }

    $('.mp-header__burger').click( function (){
        $('.mp-header__mobile').css('display', 'block');
        $("html").addClass("noscroll-mobile");
    });

    $('.mp-header__close').click( function (){
        $('.mp-header__mobile').css('display', 'none');
        $("html").removeClass("noscroll-mobile");
    });

    $('.mp-header__report-link-mobile').click(function (event) {

        let target = $($(this).attr('data-to'));

        if( target.length ) {
            $('html, body').animate({
                scrollTop: target.offset().top
            }, 500);
        }

        $('.mp-header__mobile').css('display', 'none');
        //$('.header__burger').removeClass('active');
        $("html").removeClass("noscroll-mobile");
    });

    $('.mp-header__open-form').click(function () {
        $('.mp-modal_overlay,.mp-modal_form').fadeIn(500);
    });

    $(".mp-modal_overlay,.mp-modal_form_close").click(function () {
        $('.mp-modal_overlay,.mp-modal_form').fadeOut(500);
    });
}
